import { useFormik } from 'formik';
import {
	ForgotPasswordFormValues,
	ForgotPasswordSchema,
	toast,
	ForgotPassword as View,
} from 'ui-components';
import { tryCatch } from 'utils';

import { useSendUpdatePasswordEmail } from '~auth/queries/useSendUpdatePasswordEmail';

export const ForgotPassword = () => {
	const sendEmail = useSendUpdatePasswordEmail();
	const form = useFormik<ForgotPasswordFormValues>({
		initialValues: {
			email: '',
		},
		validationSchema: ForgotPasswordSchema,
		onSubmit: (values, helpers) => {
			toast.promise(
				async () => {
					const [error] = await tryCatch(sendEmail.mutateAsync(values));
					if (error) {
						helpers.setSubmitting(false);
						throw error;
					}
				},
				{
					loading: 'Sending reset link...',
					success: 'Reset link sent!',
					error: (e) => e.message || 'Something went wrong!',
				}
			);
		},
	});

	return <View form={form} />;
};
